export class SpcialistDto {
  public  FirstName:string;
  public  BirthDate:string;
  public  gender:string;
  public  MidName:string;
  public  LastName:string;
  public  PhoneNumber:string;
  public  IdCardNumber:string;
  public  address:string;
  public  Employer:string;
  public  nationality:string;
  public  Email:string;
  public  Password:string;
  public  id:number;
  public attachment:string;
  public attachmentName:string;
  public education:string;
  public experienceYears:string;
  public Job:string;
  public FileNameURL:string;
  public scientificDegree:string;
  public joinedInYourConsultant:boolean;
  public consultationPriceInHour:number;
  public consultationPriceIn45Minute:number;
  public consultationPriceIn30Minute:number;
  public consultationPriceIn15Minute:number;
}
